import React from "react";
import { Typography, Box } from "@mui/material";

export const Agreement = {
  UserContract: "UserContract",
  TermsOfUse: "TermsOfUse",
  PrivacyPolicy: "PrivacyPolicy",
};

export const KvkkAydinlatmaMetniContent = () => (
  <>
    <Typography variant="body2" sx={{ mb: 2, color: "#444", lineHeight: 1.7 }}>
      Bu Aydınlatma Metni; 24/03/2016 tarihli ve 6698 sayılı Kişisel Verilerin Korunması Kanunu ("Kanun") uyarınca, kişisel verileri işlenen ilgili kişilerin bilgilendirilmesi amacıyla hazırlanmıştır.
    </Typography>

    <Typography variant="subtitle1" sx={{ fontWeight: 700, color: "#0D9488", mt: 3, mb: 1 }}>
      1. Veri Sorumlusunun Kimliği
    </Typography>
    <Typography variant="body2" sx={{ color: "#444", lineHeight: 1.7 }}>
      Kişisel verileriniz, veri sorumlusu sıfatıyla Zenan Bilişim Teknolojileri A.Ş. tarafından işlenmektedir.
    </Typography>
    <Typography variant="body2" sx={{ color: "#444", lineHeight: 1.7, mt: 1 }}>
      <strong>Adres:</strong> OSTİM OSB Mahallesi, Cevat Dündar Caddesi, No:1/1/49<br />
      06374 OSTİM Teknopark, Yenimahalle / Ankara
    </Typography>
    <Typography variant="body2" sx={{ color: "#444", lineHeight: 1.7, mt: 1 }}>
      <strong>E-posta:</strong> info@zenambilisim.com.tr
    </Typography>
    <Typography variant="body2" sx={{ color: "#444", lineHeight: 1.7 }}>
      <strong>Telefon:</strong> +90 555 257 92 05
    </Typography>
    <Typography variant="body2" sx={{ color: "#444", lineHeight: 1.7 }}>
      <strong>MERSİS No:</strong> 0997126677000001
    </Typography>

    <Typography variant="subtitle1" sx={{ fontWeight: 700, color: "#0D9488", mt: 3, mb: 1 }}>
      2. İşlenen Kişisel Veri Kategorileri
    </Typography>
    <Typography variant="body2" sx={{ color: "#444", lineHeight: 1.7 }}>
      Uygulamanın kullanımı kapsamında aşağıdaki kişisel verileriniz işlenebilmektedir:
    </Typography>
    <Typography variant="body2" sx={{ color: "#444", lineHeight: 1.7, mt: 1 }}>
      <strong>Kimlik Bilgileri:</strong> Ad, soyad
    </Typography>
    <Typography variant="body2" sx={{ color: "#444", lineHeight: 1.7 }}>
      <strong>İletişim Bilgileri:</strong> Telefon numarası, e-posta adresi
    </Typography>
    <Typography variant="body2" sx={{ color: "#444", lineHeight: 1.7 }}>
      <strong>Mesleki Bilgiler:</strong> Branş, uzmanlık alanı, meslek unvanı
    </Typography>
    <Typography variant="body2" sx={{ color: "#444", lineHeight: 1.7 }}>
      <strong>Kullanıcı İşlem Bilgileri:</strong> Randevu bilgileri, uygulama içi mesajlaşma kayıtları, görüntülü görüşme zaman ve süre bilgileri
    </Typography>
    <Typography variant="body2" sx={{ color: "#444", lineHeight: 1.7 }}>
      <strong>Teknik Bilgiler:</strong> IP adresi, cihaz bilgileri, erişim kayıtları
    </Typography>

    <Typography variant="subtitle1" sx={{ fontWeight: 700, color: "#0D9488", mt: 3, mb: 1 }}>
      3. Kişisel Verilerin İşlenme Amaçları
    </Typography>
    <Typography variant="body2" sx={{ color: "#444", lineHeight: 1.7 }}>
      Kişisel verileriniz;
    </Typography>
    <Box component="ul" sx={{ color: "#444", lineHeight: 1.7, pl: 2, mt: 1 }}>
      <li>Uygulama üzerinden sağlık hizmetlerinin sunulmasının sağlanması</li>
      <li>Danışan ile uzman arasında görüntülü görüşme ve mesajlaşma hizmetlerinin yürütülmesi</li>
      <li>Randevu süreçlerinin planlanması ve yönetilmesi</li>
      <li>Sağlık hizmetlerine ilişkin süreçlerin mevzuata uygun şekilde yürütülmesi</li>
      <li>Bilgi güvenliği süreçlerinin sağlanması</li>
      <li>Yetkili kamu kurum ve kuruluşlarına karşı mevzuattan doğan yükümlülüklerin yerine getirilmesi</li>
      <li>Uygulama faaliyetlerinin mevzuata uygun şekilde yürütülmesi</li>
    </Box>
    <Typography variant="body2" sx={{ color: "#444", lineHeight: 1.7 }}>
      amaçlarıyla işlenmektedir.
    </Typography>

    <Typography variant="subtitle1" sx={{ fontWeight: 700, color: "#0D9488", mt: 3, mb: 1 }}>
      4. Kişisel Verilerin Aktarılması
    </Typography>
    <Typography variant="body2" sx={{ color: "#444", lineHeight: 1.7 }}>
      Kişisel verileriniz;
    </Typography>
    <Box component="ul" sx={{ color: "#444", lineHeight: 1.7, pl: 2, mt: 1 }}>
      <li>Sağlık hizmeti sunumunun sağlanabilmesi amacıyla ilgili danışanlara ve yetkili sağlık kuruluşlarına,</li>
      <li>Bilgi teknolojileri altyapısının sağlanması kapsamında hizmet alınan bilişim ve barındırma hizmeti sağlayıcılarına,</li>
      <li>Hukuki yükümlülüklerin yerine getirilmesi amacıyla yetkili kamu kurum ve kuruluşlarına</li>
    </Box>
    <Typography variant="body2" sx={{ color: "#444", lineHeight: 1.7 }}>
      Kanun'un 8 ve 9. maddelerinde öngörülen şartlara uygun olarak aktarılabilmektedir.
    </Typography>

    <Typography variant="subtitle1" sx={{ fontWeight: 700, color: "#0D9488", mt: 3, mb: 1 }}>
      5. Kişisel Veri Toplamanın Yöntemi ve Hukuki Sebebi
    </Typography>
    <Typography variant="body2" sx={{ color: "#444", lineHeight: 1.7 }}>
      Kişisel verileriniz;
    </Typography>
    <Box component="ul" sx={{ color: "#444", lineHeight: 1.7, pl: 2, mt: 1 }}>
      <li>Mobil uygulama ve/veya web tabanlı platformlar üzerinden</li>
      <li>Tamamen veya kısmen otomatik yollarla</li>
    </Box>
    <Typography variant="body2" sx={{ color: "#444", lineHeight: 1.7 }}>
      toplanmaktadır.
    </Typography>
    <Typography variant="body2" sx={{ color: "#444", lineHeight: 1.7, mt: 1 }}>
      Kişisel verileriniz, Kanun'un;
    </Typography>
    <Box component="ul" sx={{ color: "#444", lineHeight: 1.7, pl: 2, mt: 1 }}>
      <li>5/2(c) maddesi (bir sözleşmenin kurulması veya ifasıyla doğrudan doğruya ilgili olması),</li>
      <li>5/2(ç) maddesi (hukuki yükümlülüğün yerine getirilmesi),</li>
      <li>5/2(f) maddesi (veri sorumlusunun meşru menfaati)</li>
    </Box>
    <Typography variant="body2" sx={{ color: "#444", lineHeight: 1.7 }}>
      hukuki sebeplerine dayanılarak işlenmektedir.
    </Typography>

    <Typography variant="subtitle1" sx={{ fontWeight: 700, color: "#0D9488", mt: 3, mb: 1 }}>
      6. İlgili Kişinin Hakları
    </Typography>
    <Typography variant="body2" sx={{ color: "#444", lineHeight: 1.7 }}>
      Kanun'un 11. maddesi uyarınca ilgili kişi olarak;
    </Typography>
    <Box component="ul" sx={{ color: "#444", lineHeight: 1.7, pl: 2, mt: 1 }}>
      <li>Kişisel verilerinizin işlenip işlenmediğini öğrenme</li>
      <li>İşlenmişse buna ilişkin bilgi talep etme</li>
      <li>İşlenme amacını ve amaca uygun kullanılıp kullanılmadığını öğrenme</li>
      <li>Yurt içinde veya yurt dışında aktarıldığı üçüncü kişileri bilme</li>
      <li>Eksik veya yanlış işlenmiş olması hâlinde düzeltilmesini isteme</li>
      <li>Kanun'a uygun olarak silinmesini veya yok edilmesini isteme</li>
      <li>İşlemlerin aktarıldığı üçüncü kişilere bildirilmesini isteme</li>
      <li>İşlenen verilerin münhasıran otomatik sistemler vasıtasıyla analiz edilmesi suretiyle aleyhinize bir sonucun ortaya çıkmasına itiraz etme</li>
      <li>Kanun'a aykırı olarak işlenmesi sebebiyle zarara uğramanız hâlinde zararın giderilmesini talep etme</li>
    </Box>
    <Typography variant="body2" sx={{ color: "#444", lineHeight: 1.7 }}>
      haklarına sahipsiniz.
    </Typography>
    <Typography variant="body2" sx={{ color: "#444", lineHeight: 1.7, mt: 1 }}>
      Bu haklarınıza ilişkin taleplerinizi yazılı olarak veya <strong>info@zenambilisim.com.tr</strong> e-posta adresi üzerinden iletebilirsiniz.
    </Typography>

    <Typography variant="subtitle1" sx={{ fontWeight: 700, color: "#0D9488", mt: 3, mb: 1 }}>
      7. Aydınlatma Metni Hakkında
    </Typography>
    <Typography variant="body2" sx={{ color: "#444", lineHeight: 1.7 }}>
      Bu metin, kişisel verilerinizin işlenmesine ilişkin bilgilendirme amacıyla hazırlanmış olup, herhangi bir sözleşme kurulması, açık rıza alınması veya onay beyanı niteliği taşımamaktadır.
    </Typography>
  </>
);
